
import { defineComponent } from 'vue'
import Slideshow from './header/Slideshow.vue'
import { subpages } from '@/data/navigation/subpages'
import { langs } from '@/data/navigation/langs'
import { supportedLanguages, SupportedLanguage } from '@/scripts/root/language'

interface Subpage {
  text: string
  link?: string
  links?: Record<SupportedLanguage, string>
  scrollTo?: string
}

export default defineComponent({
  data(): { subpages: Subpage[]; langs: typeof langs } {
    return {
      subpages,
      langs,
    }
  },
  components: {
    Slideshow,
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    getAppStoreLink(): string {
      const appStoreSubpage = this.subpages.find(
        (subpage) => subpage.text === 'appStore'
      )
      if (appStoreSubpage) {
        return this.getLinkForCurrentLanguage(appStoreSubpage)
      }
      return '#'
    },
    getGoogleplayLink(): string {
      const appStoreSubpage = this.subpages.find(
        (subpage) => subpage.text === 'googlePlay'
      )
      if (appStoreSubpage) {
        return this.getLinkForCurrentLanguage(appStoreSubpage)
      }
      return '#'
    },
  },
  methods: {
    isLanguageKey(key: string): key is SupportedLanguage {
      return supportedLanguages.includes(key as SupportedLanguage)
    },
    getLinkForCurrentLanguage(subpage: Subpage) {
      if (subpage.links && this.isLanguageKey(this.currentLanguage)) {
        return subpage.links[this.currentLanguage]
      }
      return '#'
    },
  },
})
